import React, { useCallback, useEffect, useState } from "react";
import { baseURL, secretKey } from "../../util/config";
import { PageHead, Table, img, when } from "./kit";

// Ozel cerceve: disaridan cerceve resmi yukle -> otomatik magaza olcusune gelir -> ID'ye ver.
const hdr = () => ({ key: secretKey, Authorization: sessionStorage.getItem("token") || "" });
const req = async (path, { method = "GET", body, form } = {}) => {
  const r = await fetch(`${baseURL}customFrame/${path}`, {
    method,
    headers: form ? hdr() : { ...hdr(), ...(body ? { "Content-Type": "application/json" } : {}) },
    body: form || (body ? JSON.stringify(body) : undefined),
  });
  try {
    return await r.json();
  } catch (e) {
    return { status: false, message: "Sunucudan geçersiz yanıt." };
  }
};
const inp = { width: "100%", padding: "8px 10px", border: "1px solid #E5E7EB", borderRadius: 8, fontSize: 14 };

// onizlemede ornek foto ustune cerceve
const Onizleme = ({ src, foto, size = 220 }) => (
  <div style={{ width: size, height: size, position: "relative", background: "#140F32", borderRadius: 16 }}>
    <div
      style={{
        position: "absolute",
        left: size * (145 / 512),
        top: size * (145 / 512),
        width: size * (222 / 512),
        height: size * (222 / 512),
        borderRadius: "50%",
        background: foto ? `url(${foto}) center/cover` : "#C8968C",
      }}
    />
    {src && <img src={src} alt="" style={{ position: "absolute", inset: 0, width: size, height: size }} />}
  </div>
);

const CustomFrames = () => {
  const [onz, setOnz] = useState(null); // {file, image, info}
  const [busy, setBusy] = useState(false);
  const [id, setId] = useState("");
  const [kisi, setKisi] = useState(null);
  const [ad, setAd] = useState("");
  const [gun, setGun] = useState(0);
  const [tak, setTak] = useState(true);
  const [list, setList] = useState([]);

  const load = useCallback(async () => {
    const r = await req("admin/list");
    if (r?.status) setList(r.list);
  }, []);
  useEffect(() => {
    load();
  }, [load]);

  const yukle = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    const fd = new FormData();
    fd.append("image", f);
    setBusy(true);
    setOnz(null);
    const r = await req("admin/preview", { method: "POST", form: fd });
    setBusy(false);
    e.target.value = "";
    if (!r?.status) return window.alert(r?.message || "İşlenemedi");
    setOnz(r);
    if (!ad) setAd(f.name.replace(/\.[^.]+$/, "").slice(0, 40));
  };

  const bul = async () => {
    setKisi(null);
    if (!id.trim()) return;
    const r = await req(`admin/user?id=${encodeURIComponent(id.trim())}`);
    if (!r?.status) return window.alert(r?.message || "Bulunamadı");
    setKisi(r.user);
  };

  const ver = async () => {
    if (!onz) return window.alert("Önce çerçeve resmini yükle");
    if (!kisi) return window.alert("Önce kişiyi ID ile bul");
    if (!window.confirm(`"${ad || "Özel çerçeve"}" çerçevesi ${kisi.name} (${kisi.uniqueID}) kişisine ${Number(gun) ? gun + " günlüğüne" : "süresiz"} verilsin mi?`)) return;
    setBusy(true);
    const r = await req("admin/grant", { method: "POST", body: { file: onz.file, uniqueID: kisi.uniqueID, name: ad, days: Number(gun) || 0, equip: tak } });
    setBusy(false);
    if (!r?.status) return window.alert(r?.message || "Verilemedi");
    window.alert(`Verildi: ${r.user}. Uygulamayı yeniden açınca görünür.`);
    setOnz(null);
    setKisi(null);
    setId("");
    setAd("");
    load();
  };

  const geriAl = async (g) => {
    if (!window.confirm(`${g.userName} kişisinden "${g.name}" çerçevesi geri alınsın mı?`)) return;
    const r = await req(`admin/${g._id}/revoke`, { method: "POST" });
    if (!r?.status) return window.alert(r?.message || "İşlem başarısız");
    load();
  };

  return (
    <>
      <PageHead title="Özel Çerçeve" sub="Dışarıdan çerçeve yükle → otomatik ölçüye gelir → istediğin kişiye ver (mağazada satılmaz)" />
      <div className="card">
        <div className="card-body d-flex" style={{ gap: 24, flexWrap: "wrap" }}>
          <div>
            <Onizleme src={onz ? img(onz.image) : ""} foto={kisi?.image ? img(kisi.image) : ""} />
            <label className="btn btn-primary w-100" style={{ marginTop: 10 }}>
              {busy ? "İşleniyor…" : onz ? "Başka resim yükle" : "1. Çerçeve resmini yükle"}
              <input type="file" accept="image/png,image/webp" hidden onChange={yukle} disabled={busy} />
            </label>
            <div style={{ fontSize: 11, color: "#6B7280", maxWidth: 220, marginTop: 6 }}>
              Ortası boş (şeffaf) PNG/WebP. Delik otomatik bulunur, 512px'e ve foto boyuna oturtulur.
            </div>
            {onz?.info && <div style={{ fontSize: 10.5, color: "#9CA3AF", maxWidth: 220, marginTop: 4 }}>{onz.info}</div>}
          </div>
          <div style={{ flex: 1, minWidth: 260, maxWidth: 420 }}>
            <label style={{ fontSize: 13, fontWeight: 600 }}>2. Kişinin ID'si</label>
            <div className="d-flex" style={{ gap: 6 }}>
              <input style={inp} value={id} onChange={(e) => setId(e.target.value)} onKeyDown={(e) => e.key === "Enter" && bul()} placeholder="ör. 9997760" />
              <button className="btn btn-outline-primary" onClick={bul}>
                Bul
              </button>
            </div>
            {kisi && (
              <div className="d-flex align-items-center" style={{ gap: 8, margin: "8px 0", fontSize: 13 }}>
                {kisi.image && <img src={img(kisi.image)} alt="" style={{ width: 32, height: 32, borderRadius: 16, objectFit: "cover" }} />}
                <b>{kisi.name}</b> <span style={{ color: "#6B7280" }}>ID {kisi.uniqueID}</span>
              </div>
            )}
            <label style={{ fontSize: 13, fontWeight: 600, marginTop: 10 }}>Çerçeve adı</label>
            <input style={inp} value={ad} onChange={(e) => setAd(e.target.value)} placeholder="ör. Sunucu" />
            <label style={{ fontSize: 13, fontWeight: 600, marginTop: 10 }}>Süre (gün) — 0 = süresiz</label>
            <input style={inp} type="number" min={0} value={gun} onChange={(e) => setGun(e.target.value)} />
            <label className="d-flex align-items-center" style={{ gap: 8, marginTop: 10, fontSize: 13 }}>
              <input type="checkbox" checked={tak} onChange={(e) => setTak(e.target.checked)} /> Hemen tak (profilde direkt görünsün)
            </label>
            <button className="btn btn-success w-100" style={{ marginTop: 14 }} disabled={busy || !onz || !kisi} onClick={ver}>
              3. Çerçeveyi ver
            </button>
          </div>
        </div>
      </div>

      <Table
        head={["Çerçeve", "Kişi", "Süre", "Tarih", ""]}
        empty="Henüz özel çerçeve verilmedi."
        rows={list.map((g) => (
          <tr key={g._id}>
            <td>
              <div className="d-flex align-items-center" style={{ gap: 10 }}>
                <Onizleme src={img(g.image)} size={56} />
                <b>{g.name}</b>
              </div>
            </td>
            <td>
              {g.userName}
              <div style={{ fontSize: 12, color: "#6B7280" }}>ID {g.uniqueID}</div>
            </td>
            <td>{g.days ? `${g.days} gün` : "Süresiz"}</td>
            <td style={{ fontSize: 12 }}>{when(g.createdAt)}</td>
            <td>
              <button className="btn btn-outline-danger btn-sm" onClick={() => geriAl(g)}>
                Geri al
              </button>
            </td>
          </tr>
        ))}
      />
    </>
  );
};

export default CustomFrames;
